"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _Theme = require("../../Theme");

var _Box = require("../Box");

var _Flex = require("../Flex");

var _MousePositionContext = require("./MousePositionContext");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: none;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MAX_BAR_HEIGHT = 80;
var MIN_BAR_HEIGHT = 10;
var BAR_HEIGHT_RANGE = MAX_BAR_HEIGHT - MIN_BAR_HEIGHT;
var LABEL_OFFSET = 10;
// the actual visible bit of the bar
var BarBox = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Bar__BarBox",
  componentId: "vx0va3-0"
})(["transition:height 0.8s ease;position:relative;background:", ";margin-right:2px;margin-bottom:-1px;:last-child{margin-right:0;}flex:1;cursor:pointer;border-top-left-radius:1px;border-top-right-radius:1px;@media (min-width:", "px){:hover{background:", ";}}"], function (props) {
  return props.isHighlighted ? (0, _helpers.color)("black60") : (0, _helpers.color)("black10");
}, _Theme.breakpoints.sm, function (props) {
  return props.isHighlighted ? (0, _helpers.color)("black60") : (0, _helpers.color)("black30");
});
var BaseLabelPositioner = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Bar__BaseLabelPositioner",
  componentId: "vx0va3-1"
})(["", ";transform:translateX(-50%);pointer-events:none;border-radius:2px;"], _helpers.media.xs(_templateObject()));
var HoverLabelPositioner = (0, _styledComponents.default)(BaseLabelPositioner).withConfig({
  displayName: "Bar__HoverLabelPositioner",
  componentId: "vx0va3-2"
})(["z-index:2;position:fixed;background-color:", ";box-shadow:0 1px 4px 0 rgba(0,0,0,0.15);"], (0, _helpers.color)("white100"));
var HighlightLabelPositioner = (0, _styledComponents.default)(BaseLabelPositioner).withConfig({
  displayName: "Bar__HighlightLabelPositioner",
  componentId: "vx0va3-3"
})(["z-index:1;position:absolute;left:50%;bottom:100%;transition:opacity 0.8s ease;flex-direction:column;align-items:center;"]);
var HighlightLabelBox = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Bar__HighlightLabelBox",
  componentId: "vx0va3-4"
})(["position:relative;background-color:", ";border:1px solid ", ";border-radius:2px;text-align:center;"], (0, _helpers.color)("white100"), (0, _helpers.color)("black10")); // the little dotted line which connects the label to the bar

var LabelLine = function LabelLine() {
  return _react.default.createElement("svg", {
    width: "2",
    height: "10",
    viewBox: "0 0 2 10"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 1.11111V0H1.5V1.11111H0.5ZM0.5 4.44444V2.22222H1.5V4.44444H0.5ZM0.5 7.77778V5.55556H1.5V7.77778H0.5ZM0.5 10V8.88889H1.5V10H0.5Z",
    fill: (0, _helpers.color)("black30")
  }));
};

LabelLine.displayName = "LabelLine";

var BarHoverLabel = function BarHoverLabel(_ref) {
  var children = _ref.children;
  var ref = (0, _react.useRef)(null);

  var _useContext = (0, _react.useContext)(_MousePositionContext.MousePositionContext),
      x = _useContext.x,
      y = _useContext.y;

  if (ref.current) {
    // position outside of the render loop to avoid GC churn
    ref.current.style.top = y - LABEL_OFFSET - ref.current.offsetHeight + "px";
    ref.current.style.left = x + "px";
  }

  return _react.default.createElement(HoverLabelPositioner, {
    ref: ref
  }, children);
};

BarHoverLabel.displayName = "BarHoverLabel";

var HighlightLabel = function HighlightLabel(_ref2) {
  var children = _ref2.children,
      onMeasureHighlightLabel = _ref2.onMeasureHighlightLabel,
      opacity = _ref2.opacity;
  var ref = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    onMeasureHighlightLabel(ref.current.offsetHeight);
  });
  return _react.default.createElement(HighlightLabelPositioner, {
    ref: ref,
    style: {
      opacity: opacity
    }
  }, _react.default.createElement(HighlightLabelBox, null, children), _react.default.createElement(LabelLine, null));
};

HighlightLabel.displayName = "HighlightLabel";

/**
 * Bar is the main component responsible for rendering an individual bar
 * in a bar chart.
 *
 * It not publically usable
 *
 * It is responsible for rendering a visible bar of a specific height and 0-2 labels.
 *
 * If a 'highlight' label is given, the bar will measure itself to help it's parent
 * container set an appropriate min-height property. This prevents the highlight
 * label from obscuring content above the bar chart.
 */
var Bar = function Bar(_ref3) {
  var heightPercent = _ref3.heightPercent,
      label = _ref3.label,
      highlightLabel = _ref3.highlightLabel,
      hasEnteredViewport = _ref3.hasEnteredViewport,
      onMeasureHeight = _ref3.onMeasureHeight;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      hover = _useState2[0],
      setHover = _useState2[1]; // Before the bar has entered the view port it will have a height of 0
  // but it still needs to know how bit it will eventually be once visible,
  // to allow the parent BarChart container to set an appropriate min-height
  // property


  var finalBarHeight = // bar heights start at MIN_BAR_HEIGHT, unless the intended height === 0
  heightPercent === 0 ? 0 : MIN_BAR_HEIGHT + BAR_HEIGHT_RANGE / 100 * heightPercent;
  var currentHeight = hasEnteredViewport ? finalBarHeight : 0;
  return _react.default.createElement(BarBox, {
    style: {
      height: currentHeight
    },
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    isHighlighted: Boolean(highlightLabel)
  }, highlightLabel && _react.default.createElement(HighlightLabel, {
    opacity: hasEnteredViewport ? 1 : 0,
    onMeasureHighlightLabel: function onMeasureHighlightLabel(labelHeight) {
      return onMeasureHeight(labelHeight + finalBarHeight);
    }
  }, highlightLabel), hover && label && _react.default.createElement(BarHoverLabel, null, label));
};

exports.Bar = Bar;
Bar.displayName = "Bar";
//# sourceMappingURL=Bar.js.map